import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Employee } from '@/shared/model/employee.model';
import EmployeeExtendedService from '@/account/spe/employee-authentication/employee-extended.service';

@Component
export default class EmployeeSearch extends Vue {
  private employeeExtendedService = new EmployeeExtendedService();

  @Prop({ type: Object, default: null })
  value!: Employee | null;

  @Prop({ type: Boolean, default: false })
  error!: boolean;

  @Prop({ type: Array, default: () => [] })
  errorMessages!: string[];

  private search = '';
  private isLoading = false;
  private employees: Employee[] = [];
  private timeout: any = 0;

  private get selectedEmployee(): Employee | null {
    return this.value;
  }

  private set selectedEmployee(val: Employee | null) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  @Watch('search')
  onSearchChange(val: string): void {
    if (!val || val.length < 2) {
      return;
    }

    if (this.selectedEmployee && (this.selectedEmployee.name === val || `${this.selectedEmployee.number}` === val)) {
      return;
    }

    this.employees = [];
    this.isLoading = true;
    this.searchDebounced();
  }

  private searchDebounced(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.employeeExtendedService
        .search(this.search)
        .then(res => {
          this.employees = res || [];
        })
        .catch(error => {
          this.employees = [];
          this.$emit('error', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, 300);
  }

  customFilter(item: Employee, queryText: string): boolean {
    const search = queryText.toLowerCase();
    return (item.name || '').toLowerCase().includes(search) || `${item.number}`.includes(search);
  }
}
